module.exports = __webpack_public_path__ + "static/card-top-63ab054f57a74cf1eb0b971c82152e51.jpg";